$ = jQuery;
export const accordion = { 
  init: function() {
    $(".accordion-item").each(function() {
      const h = $(this)
        .find(".accordion__content")
        .innerHeight();
      $(this)
        .find(".accordion__content")
        .css({ maxHeight: 0 });
      $(this)
        .find("label")
        .on("click", function(e) {
          e.preventDefault();
          if (
            !$(this)
              .parent()
              .hasClass("opened")
          ) {
            $(this)
              .parents(".archipel-accordion")
              .find(".accordion__content")
              .css({ maxHeight: 0 });
            $(this)
              .parents(".archipel-accordion")
              .find(".accordion-item")
              .removeClass("opened");
            $(this)
              .parent()
              .find(".accordion__content")
              .css({ maxHeight: h + 40 + "px" });
            $(this)
              .parent()
              .addClass("opened");
          } else {
            $(this)
              .parent()
              .find(".accordion__content")
              .css({ maxHeight: 0 });
            $(this)
              .parent()
              .removeClass("opened");
          }
        });
    });
  },
};